import {
  createStandardAction,
  ActionType,
  createReducer,
  action,
} from 'typesafe-actions';
import produce from 'immer';
import {TSectionList} from 'modules/timeline';
import {FileEntity} from 'lib/api/vodInfo';
import {
  getSectionPlay,
  // getFileIndexByTime,
  // getTotalDurationByIndex,
} from 'lib/playUtils';

/**
 * 컷 편집 상태 리덕스로 관리
 */

export type TCutState = {
  editType: number;
  status: boolean;
  isFirst: boolean;
  cutPlayingIdx: number;
  infos: TCutInfos[][];
  lists: TCutLists[][];
  shades: TCutLists[][];
  sectionNode: any;
  shadeDuration: number[];
  type: string;
};

export type TCutLists = {
  idx?: number;
  startTime: number;
  endTime: number;
  duration: number;
  sectionIdx?: number;
};

export type TCutInfos = {
  // fileOrder: number;
  // filePath: string;
  // fileInfoKey: string;
  fileIdx: number;
  cutIdx: number;
  cutStartTime: number;
  cutEndTime: number;
  // cutTotalStartTime: number;
  // cutTotalDuration: number;
  // cutIdx: number;
  vodUrl: string;
  sectionIdx?: number;
};

const initInfos = [
  [
    {
      fileIdx: 0,
      cutIdx: 0,
      cutStartTime: 0,
      cutEndTime: 0,
      vodUrl: '',
    },
  ],
];

const initLists = [
  [
    {
      idx: 0,
      startTime: 0,
      endTime: 0,
      duration: 0,
      sectionIdx: 0,
    },
  ],
];

const initInfosFunc = (
  sectionLists: TSectionList[],
  fileList: FileEntity[],
) => {
  const arr = [] as any;
  for (const {startTime, endTime} of sectionLists) {
    // const startFileIdx = getFileIndexByTime(fileList, startTime); // 섹션 시간의 파일 인덱스
    // const endFileIdx = getFileIndexByTime(fileList, endTime); // 섹션 끝 시간의 파일 인덱스
    const section = getSectionPlay(fileList, startTime, endTime);

    const tmpArr = [] as any;
    for (const {fileIdx, cutStartTime, cutEndTime} of section) {
      tmpArr.push({
        fileIdx,
        cutIdx: 0,
        cutStartTime,
        cutEndTime,
        vodUrl: '',
      });
    }
    arr.push(tmpArr);
  }

  return arr;
};

const initListsFunc = (sectionLists: TSectionList[]) => {
  const arr = [];
  let i = 0;
  for (const {startTime, endTime} of sectionLists) {
    arr.push([
      {
        idx: 0,
        startTime,
        endTime,
        duration: 0,
        sectionIdx: i++,
      },
    ]);
  }

  return arr;
};

// let cutIdx = 0;
export const initialState: TCutState = {
  editType: 0, // 0: 컷 편집
  status: false,
  isFirst: true, // 처음 편집 상태 여부
  cutPlayingIdx: 0, // 편집 구간 플레이 idx
  infos: initInfos,
  lists: initLists,
  shades: initLists,
  sectionNode: [],
  shadeDuration: [], // 그림자 영역 duration
  type: '',
};

export const INITIALIZE = 'cut/INITIALIZE';
export const INIT_INFO_LIST = 'cut/INIT_INFO_LIST';
export const INIT_LISTS_LIST = 'cut/INIT_LISTS_LIST';
const SET_STATUS_CUT = 'cut/SET_STATUS_CUT';
const CHANGE_PLAYING_IDX_CUT = 'cut/CHANGE_PLAYING_IDX_CUT';
const ADD_CUT = 'cut/ADD_CUT';
export const ADD_LISTS = 'cut/ADD_LISTS';
const ADD_SHADES = 'cut/ADD_SHADES';
const ADD_CUT_SECTION = 'cut/ADD_CUT_SECTION';
const SET_SHADE_DURATION = 'cut/SET_SHADE_DURATION';

export const initializeAction = createStandardAction(INITIALIZE)();
export const initInfoListAction = createStandardAction(INIT_INFO_LIST)<
  TSectionList[],
  FileEntity[]
>();
export const initListsAction =
  createStandardAction(INIT_LISTS_LIST)<TSectionList[]>();
export const setStatusCutAction =
  createStandardAction(SET_STATUS_CUT)<boolean>();
export const changePlayingIdxCutAction = createStandardAction(
  CHANGE_PLAYING_IDX_CUT,
)<number>();
export const addCutAction = createStandardAction(ADD_CUT)<
  TCutInfos[],
  number
>();
export const addListsAction = createStandardAction(ADD_LISTS)<
  TCutLists[],
  number
>();
export const addShadesAction = createStandardAction(ADD_SHADES)<
  TCutLists[],
  number
>();
export const addCutSectionAction = createStandardAction(ADD_CUT_SECTION)<
  Node,
  number
>();
export const setShadeDuration = createStandardAction(SET_SHADE_DURATION)<
  number,
  number
>();

type actions = {
  initializeAction: typeof initializeAction;
  initInfoListAction: typeof initInfoListAction;
  initListsAction: typeof initListsAction;
  setStatusCutAction: typeof setStatusCutAction;
  changePlayingIdxCutAction: typeof changePlayingIdxCutAction;
  addCutAction: typeof addCutAction;
  addListsAction: typeof addListsAction;
  addShadesAction: typeof addShadesAction;
  addCutSectionAction: typeof addCutSectionAction;
  setShadeDuration: typeof setShadeDuration;
};
type CutAction = ActionType<actions>;

const cut = createReducer<TCutState, CutAction>(initialState, {
  [INITIALIZE]: (state) =>
    produce(state, (draft) => {
      draft.editType = 0;
      draft.status = false;
      draft.isFirst = true;
      draft.cutPlayingIdx = 0;
      draft.infos = initInfos;
      draft.lists = initLists;
      draft.shades = initLists;
      draft.sectionNode = [];
      draft.shadeDuration = [];
      draft.type = INITIALIZE;
    }),
  [INIT_INFO_LIST]: (state, {payload: sectionLists, meta: fileLists}) => ({
    ...state,
    ...action,
    infos: initInfosFunc(sectionLists, fileLists),
    // lists: initListsFunc(length),
  }),
  [INIT_LISTS_LIST]: (state, {payload: sectionLists}) => ({
    ...state,
    ...action,
    lists: initListsFunc(sectionLists),
    // lists: initListsFunc(length),
  }),
  [SET_STATUS_CUT]: (state, action) => ({
    ...state,
    ...action,
    editType: 0,
    status: action.payload,
  }),
  [CHANGE_PLAYING_IDX_CUT]: (state, {payload: idx}) =>
    produce(state, (draft) => {
      draft.cutPlayingIdx = idx;
    }),
  [ADD_CUT]: (state, {payload: files, meta: sectionIdx}) =>
    produce(state, (draft) => {
      // draft.infos = initInfos; // 초기화 하고 다시 전체 넣음
      // draft.infos.splice(0);
      const dInfos: any = [];
      files.map((file, idx) => {
        dInfos[idx] = file;
        dInfos[idx].cutIdx = idx;
        dInfos[idx].sectionIdx = sectionIdx;
      });
      draft.infos[sectionIdx] = dInfos;
    }),
  [ADD_LISTS]: (state, {payload: lists, meta: sectionIdx}) =>
    produce(state, (draft) => {
      // draft.lists.splice(0);
      // lists.map((list, idx) => {
      //     draft.lists[idx] = list;
      //     draft.lists[idx].idx = idx;
      //     draft.lists[idx].sectionIdx = sectionIdx;
      // });

      const dLists: any = [];
      lists.map((list, idx) => {
        dLists[idx] = list;
        dLists[idx].idx = idx;
        dLists[idx].sectionIdx = sectionIdx;
      });
      draft.lists[sectionIdx] = dLists;
      draft.type = ADD_LISTS;
    }),
  [ADD_SHADES]: (state, {payload: lists, meta: sectionIdx}) =>
    produce(state, (draft) => {
      const dLists: any = [];
      lists.map((list, idx) => {
        dLists[idx] = list;
        dLists[idx].idx = idx;
        dLists[idx].sectionIdx = sectionIdx;
      });
      draft.shades[sectionIdx] = dLists;
      draft.type = ADD_SHADES;
    }),
  [ADD_CUT_SECTION]: (state, {payload: node, meta: sectionIdx}) =>
    produce(state, (draft) => {
      draft.sectionNode[sectionIdx] = node;
    }),
  [SET_SHADE_DURATION]: (state, {payload: duration, meta: sectionIdx}) =>
    produce(state, (draft) => {
      draft.shadeDuration[sectionIdx] = Number(duration.toFixed(2));
      // draft.shadeDuration = Number(duration.toFixed(2));
    }),
});

export default cut;
